<template>
  <v-text-field
    v-model="value_"
    color="orange lighten-2"
    variant="outlined"
    :disabled="$loader.loading"
    :append-inner-icon="filter?.icon"
    :type="filter?.type"
    :label="filter?.label"
    hide-details
    :density="dense"
    @update:model-value="(v: string) => onInput(v)"
  />
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type DensityProp from '@/types/vuetify/Density'
import { type FiltersProps } from '../../types/DataTable'

export default defineComponent({
  props: {
    value: {
      type: String,
      default: '',
    },
    filter: {
      type: Object as PropType<FiltersProps>,
      required: false,
      default: () => { },
    },
    dense: {
      type: String as PropType<DensityProp>,
      default: 'default',
    },
  },
  emits: [ 'input' ],
  data() {
    return {
      value_: this.value,
    }
  },
  methods: {
    onInput(v: string): void {
      if (this.filter.onUpdate)
        this.filter.onUpdate(v)
      this.$emit('input', this.value_)
    },
  },
})
</script>
